import type { AppVueRouter } from '@modules/core/services/router/types';
import type { TranslationKeysMapper } from '@modules/i18n/types';
import { AppModule } from '@modules/core/plugins/AppModule';
import { ProfileSettingsChangeEmailModule } from '@modules/profile-settings/submodules/change-email/ProfileSettingsChangeEmailModule';
import { ProfileSettingsChangePasswordModule } from '@modules/profile-settings/submodules/change-password/ProfileSettingsChangePasswordModule';
import { ProfileSettingsConfirmationEmailModule } from '@modules/profile-settings/submodules/confirmation-email/ProfileSettingsConfirmationEmailModule';
import { ProfileSettingsGeneralModule } from '@modules/profile-settings/submodules/general-settings/ProfileSettingsGeneralModule';
import { ProfileSettingsPaymentSystemsModule } from '@modules/profile-settings/submodules/payment-systems/ProfileSettingsPaymentSystemsModule';
import { ProfileSettingsTwoFactorAuthModule } from '@modules/profile-settings/submodules/two-factor-auth/ProfileSettingsTwoFactorAuthModule';

import {
  ADMIN_PROFILE_SETTINGS_ROUTE_NAME,
  AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME,
  PROFILE_SETTINGS_PERMISSIONS,
  TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS,
  TRANSLATION_GROUP_AFFILIATE_PROFILE_SETTINGS,
} from './constants';
import {
  getAdminTranslationKeys,
  getAffiliateTranslationKeys,
} from './translations';

export class ProfileSettingsModule extends AppModule {
  protected submodules = [
    new ProfileSettingsGeneralModule(),
    new ProfileSettingsChangeEmailModule(),
    new ProfileSettingsConfirmationEmailModule(),
    new ProfileSettingsChangePasswordModule(),
    new ProfileSettingsPaymentSystemsModule(),
    new ProfileSettingsTwoFactorAuthModule(),
  ];

  addRoutes(router: AppVueRouter): void {
    router.addAdminRoute({
      name: ADMIN_PROFILE_SETTINGS_ROUTE_NAME,
      path: 'settings-profile',
      permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('./pages/ProfileSettingsPage/ProfileSettingsPage.vue'),
    });

    router.addAffiliateRoute({
      name: AFFILIATE_PROFILE_SETTINGS_ROUTE_NAME,
      path: 'settings-profile',
      permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      component: () => import('./pages/ProfileSettingsPage/ProfileSettingsPage.vue'),
    });
  }

  addMenu(): void {
  }

  addTranslationKeys(mapper: TranslationKeysMapper): void {
    mapper.addTranslationsMap(TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS, getAdminTranslationKeys);
    mapper.addTranslationsMap(TRANSLATION_GROUP_AFFILIATE_PROFILE_SETTINGS, getAffiliateTranslationKeys);
  }
}
